const ReplicaThinkingIndicator = () => {
  return <div className="flex items-center gap-2 py-2 px-3" data-sentry-component="ReplicaThinkingIndicator" data-sentry-source-file="replica-thinking-indicator.tsx">
      <span className="inline-flex items-center gap-2 ml-1">
        <span className="h-2 w-2 rounded-full bg-foreground translate-y-[2px] animate-[pulse_1.2s_ease-in-out_0ms_infinite,bounce_1s_ease-in-out_0ms_infinite]" />
        <span className="h-2 w-2 rounded-full bg-foreground translate-y-[2px] animate-[pulse_1.2s_ease-in-out_200ms_infinite,bounce_1s_ease-in-out_200ms_infinite]" />
        <span className="h-2 w-2 rounded-full bg-foreground translate-y-[2px] animate-[pulse_1.2s_ease-in-out_400ms_infinite,bounce_1s_ease-in-out_400ms_infinite]" />
      </span>
    </div>;
};
ReplicaThinkingIndicator.displayName = 'ReplicaThinkingIndicator';
export default ReplicaThinkingIndicator;